const IMPERIAL_COUNTRIES = ["US", "MM", "LR"];
const DEFAULT_SYSTEM = "metric";

export function getDefaultMeasurementSystem() {
  try {
    // Check if browser APIs are available
    if (typeof window === "undefined" || !navigator) {
      return DEFAULT_SYSTEM;
    }

    // Try multiple browser locale methods
    const userLanguage =
      navigator.language ||
      navigator.userLanguage ||
      navigator.browserLanguage ||
      navigator.systemLanguage;

    if (!userLanguage) {
      console.warn("Could not detect user language");
      return DEFAULT_SYSTEM;
    }

    // Try to get country from timezone
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timeZoneCountry = timeZone?.split("/")[1];

    // Try to get country from language code
    const languageCountry =
      userLanguage.split("-")[1] || userLanguage.toUpperCase();

    // Check localStorage for previously set preference
    const savedPreference = localStorage.getItem("measurementSystem");
    if (savedPreference) {
      return savedPreference;
    }

    // Check if any detected country uses imperial
    if (
      IMPERIAL_COUNTRIES.includes(languageCountry) ||
      IMPERIAL_COUNTRIES.includes(timeZoneCountry)
    ) {
      return "imperial";
    }

    // Additional check for US formats
    if (new Intl.NumberFormat().resolvedOptions().locale.includes("US")) {
      return "imperial";
    }

    return DEFAULT_SYSTEM;
  } catch (error) {
    console.warn("Error detecting measurement system:", error);
    return DEFAULT_SYSTEM;
  }
}
